import { render, staticRenderFns } from "./GroupLoadingSkeleton.vue?vue&type=template&id=749ad2c8"
import script from "./GroupLoadingSkeleton.vue?vue&type=script&lang=js"
export * from "./GroupLoadingSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports